import { useLocation } from 'react-router';

export function useQueryValues(): Record<string, string> {
  return Object.fromEntries(new URLSearchParams(useLocation().search));
}
